import { createFileRoute } from '@tanstack/react-router';

import { ResourceLibraryGrid } from '@/features/engagement-resources/components/ResourceLibraryGrid';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/engagement/resources/')({
  beforeLoad: () => {
    requirePermission('engagement:read');
  },
  component: WorkspaceEngagementResourcesScreen,
  staticData: { crumb: 'Engagement' },
});

function WorkspaceEngagementResourcesScreen() {
  return <ResourceLibraryGrid surface="workspace" />;
}
